import { render, staticRenderFns } from "./editShop.vue?vue&type=template&id=2081ea27"
import script from "./editShop.vue?vue&type=script&lang=js"
export * from "./editShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports